module.exports = __webpack_public_path__ + "img/tips2.b03f1d9b.png";